import React from 'react';
import useCustomerStore from '../store/use-customer-store';
import PriceBreakdownAustria from './price-breakdown-austria';
import PriceBreakdownGermany from './price-breakdown-germany';

export default function PriceBreakdown() {
  const isGermanCustomer = useCustomerStore((state) => state.isGermanCustomer);

  return isGermanCustomer ? (
    <PriceBreakdownGermany />
  ) : (
    <PriceBreakdownAustria />
  );
}
